import { AxiosInstance } from 'axios'
import { IJsonApiSerializer } from '../JsonApiSerializer'

class ReviewService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public async search(params) {
    const { data } = await this.httpClient.get('/api/reviews', { params })
    const reviews = this.serializer.parseResourceData(data.reviews, data.reviews.data)
    const pagination = data.reviews.meta

    return { reviews, pagination }
  }
}

export default ReviewService
